module.exports = __webpack_public_path__ + "img/arrow.8f955f0c.png";